import { defineComponent as z, computed as s, h as d } from "vue";
import R from "./ghl-ui.es1035.js";
import L from "./ghl-ui.es854.js";
import a from "./ghl-ui.es855.js";
import { createKey as u } from "./ghl-ui.es384.js";
import { useThemeClass as x } from "./ghl-ui.es857.js";
import B from "./ghl-ui.es1029.js";
const y = Object.assign(Object.assign({}, a.props), {
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: void 0
  }
}), V = z({
  name: "InputGroupLabel",
  props: y,
  setup(e) {
    const {
      mergedBorderedRef: n,
      mergedClsPrefixRef: r,
      inlineThemeDisabled: t
    } = L(e), m = a("Input", "-input-group-label", R, B, e, r), i = s(() => {
      const {
        size: l
      } = e, {
        common: {
          cubicBezierEaseInOut: p
        },
        self: {
          groupLabelColor: f,
          borderRadius: c,
          groupLabelTextColor: g,
          lineHeight: h,
          groupLabelBorder: b,
          [u("fontSize", l)]: v,
          [u("height", l)]: C
        }
      } = m.value;
      return {
        "--n-bezier": p,
        "--n-group-label-color": f,
        "--n-group-label-border": b,
        "--n-border-radius": c,
        "--n-group-label-text-color": g,
        "--n-font-size": v,
        "--n-line-height": h,
        "--n-height": C
      };
    }), o = t ? x("input-group-label", s(() => e.size[0]), i, e) : void 0;
    return {
      mergedClsPrefix: r,
      mergedBordered: n,
      cssVars: t ? void 0 : i,
      themeClass: o == null ? void 0 : o.themeClass,
      onRender: o == null ? void 0 : o.onRender
    };
  },
  render() {
    var e, n, r;
    const {
      mergedClsPrefix: t
    } = this;
    return (e = this.onRender) === null || e === void 0 || e.call(this), d("div", {
      class: [`${t}-input-group-label`, this.themeClass],
      style: this.cssVars
    }, (r = (n = this.$slots).default) === null || r === void 0 ? void 0 : r.call(n), this.mergedBordered ? d("div", {
      class: `${t}-input-group-label__border`
    }) : null);
  }
});
export {
  V as default,
  y as inputGroupLabelProps
};
